import { ReactNode } from 'react';

import { styled } from '@mui/material/styles';
import Radio, { RadioProps } from '@mui/material/Radio';

const BpIcon = styled('span')(() => ({
  display: 'grid',
  placeItems: 'center',
  padding: '4px',

  'input:disabled ~ &': {
    boxShadow: 'none'
  },
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  borderRadius: 4,
  border: `2px solid ${theme.palette.primary.main}`
}));

interface Props extends RadioProps {
  children: ReactNode;
}

export default function CustomRadio(props: Props) {
  const { children } = props;

  return (
    <Radio
      disableRipple
      color='default'
      checkedIcon={<BpCheckedIcon>{children}</BpCheckedIcon>}
      icon={<BpIcon>{children}</BpIcon>}
      {...props}
    />
  );
}
